"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
function CollectionItem({ children, className, ...props }) {
    return ((0, jsx_runtime_1.jsx)("li", { className: (0, uswds_react_utils_1.createClassString)('usa-collection__item', className), ...props, children: (0, jsx_runtime_1.jsx)("div", { className: "usa-collection__body", children: children }) }));
}
exports.default = CollectionItem;
